import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LicensingComponent } from './licensing.component';
import { LicensingRoutingModule } from './licensing-routing.module';
import { SharedModule } from '../shared/shared.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateCustomerComponent } from './create-customer/create-customer.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import { ViewCustomerComponent } from './view-customer/view-customer.component';
import { MatRadioModule } from '@angular/material/radio';


const routes: Routes = [
  {path:'', component: LicensingComponent}
];

@NgModule({
  declarations: [LicensingComponent, CreateCustomerComponent, ViewCustomerComponent],
  imports: [
    CommonModule,
    LicensingRoutingModule,
    RouterModule.forChild(routes),
    SharedModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule
  ],
  exports: [RouterModule]
})
export class LicensingModule { }
